import HomeContainer from './HomeContainer';

export default HomeContainer;
